import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App.svelte';
import { Router } from 'svelte-routing';

const app = new App({
  target: document.getElementById('app'),
  props: {
    url: window.location.pathname
  }
});

// Optional: Add this to help with direct URL access
window.addEventListener('popstate', () => {
  window.location.reload();
});

export default app;